import Vue from 'vue';

import {
  Button,
  Menu,
  Icon,
  FormModel,
  Input,
  Select,
  Tabs,
  Badge,
  Dropdown,
  Drawer,
  Empty,
  Notification,
  Spin,
  Popconfirm,
  Modal,
} from 'ant-design-vue';

Vue.use(Button);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(Select);
Vue.use(Tabs);
Vue.use(Badge);
Vue.use(Dropdown);
Vue.use(Drawer);
Vue.use(Empty);
Vue.use(Modal);
Vue.use(Spin);
Vue.use(Popconfirm);
Vue.prototype.$notification = Notification;
Vue.prototype.$confirm = Modal.confirm;
